import { render, staticRenderFns } from "./CreateDossier.vue?vue&type=template&id=38d1d66d&scoped=true"
import script from "./CreateDossier.vue?vue&type=script&lang=js"
export * from "./CreateDossier.vue?vue&type=script&lang=js"
import style0 from "./CreateDossier.vue?vue&type=style&index=0&id=38d1d66d&prod&scoped=true&lang=css"
import style1 from "./CreateDossier.vue?vue&type=style&index=1&id=38d1d66d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d1d66d",
  null
  
)

/* custom blocks */
import block0 from "./CreateDossier.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports